import { useRef, useState, useEffect, useContext, useCallback } from "react";
import { FaPlus } from "react-icons/fa";
import DeleteButton from "../../components/UI/AlertDialog";
import Notification from "../../components/UI/Notification";
import { Link } from "react-router-dom";
import axios from "axios";
import { getToken } from "../../utils/tokenUtils";
import ReactPaginate from "react-paginate";
import { X, MoreVertical, AlertTriangle } from "lucide-react";
import { AuthContext } from "../../contexts/AuthContext";
import { getRoleBasedRoute } from "../../utils/routeUtils";
import DropdownMenu from "../../components/UI/DropdownMenu";
import StatusBadge from "../../components/UI/StatusBadge";
import { HasPermission } from "../../components/AccessControl/ProtectedComponent";

const ShiftChange = () => {
  const [requests, setRequests] = useState([]);
  const { user, roles } = useContext(AuthContext);
  const [shifts, setShifts] = useState([]);
  const [editingRequest, setEditingRequest] = useState(null);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    shift_date: "",
    current_shift: "GS",
    requested_shift: "",
    reason: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [notification, setNotification] = useState(null);
  const token = getToken();
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    perPage: 15,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [isFiltering, setIsFiltering] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [openMenu, setOpenMenu] = useState(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    let result = [...requests];

    if (searchQuery) {
      const lowercasedQuery = searchQuery.toLowerCase();
      result = result.filter((item) => {
        const status = item.request?.status || "";
        const request_date = item.request?.request_date || "";

        return (
          item.shift_date?.toLowerCase().includes(lowercasedQuery) ||
          item.requested_shift?.toLowerCase().includes(lowercasedQuery) ||
          request_date.toLowerCase().includes(lowercasedQuery) ||
          status.toLowerCase().includes(lowercasedQuery)
        );
      });
    }

    setIsFiltering(searchQuery.length > 0);
    setFilteredData(result);
  }, [searchQuery, requests]);

  // fetch shifts
  const fetchShifts = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        "https://hrmspayroll.prepstripe.com/api/masters/shift-timings",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setLoading(false);
      const fetchedShifts = response.data?.data || [];
      setShifts(fetchedShifts);
      // Set the first shift type as default in formData
      if (fetchedShifts.length > 0) {
        setFormData((prevData) => ({
          ...prevData,
          shift: prevData.shift || fetchedShifts[0].name,
        }));
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching shifts:", error);
    }
  }, [token]);

  useEffect(() => {
    fetchShifts();
  }, [fetchShifts]);

  // Fetch shift change requests from API
  // useEffect(() => {
  //   const fetchRequests = async () => {
  //     try {
  //       const response = await fetch(`${API_URL}/swipe-records`);
  //       if (!response.ok) {
  //         throw new Error("Failed to fetch requests");
  //       }
  //       // const data = await response.json();
  //       setRequests(response.data?.data?.data);
  //     } catch (err) {
  //       setError(err.message);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchRequests();
  // }, []);

  const fetchShiftChange = useCallback(
    async (page = 1) => {
      axios
        .get(
          `https://hrmspayroll.prepstripe.com/api/shift-changes?page=${page}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .then((response) => {
          setRequests(response.data?.data);
          setPagination({
            currentPage: response.data?.current_page || 1,
            totalPages: response.data?.last_page || 1,
            totalItems: response.data?.total || 0,
            perPage: response.data?.per_page || 10,
          });
        })
        .catch((error) => {
          console.error("Error fetching shift change requests:", error);
        });
    },
    [token],
  );

  // Fetch shift change requests from API
  useEffect(() => {
    fetchShiftChange();
  }, [fetchShiftChange]);

  // const handleAddOrEditRequest = (e) => {
  //   e.preventDefault();
  //   if (editingRequest) {
  //     setRequests(requests.map(req => req.id === editingRequest.id ? { ...req, ...formData } : req));
  //     setNotification("Shift change request updated successfully");
  //   } else {
  //     setRequests([...requests, { id: Date.now(), ...formData, status: "Pending" }]);
  //     setNotification("Shift change request added successfully");
  //   }
  //   setShowModal(false);
  //   setEditingRequest(null);
  //   resetForm();
  // };

  // const handleAddOrEditRequest = async (e) => {
  //   e.preventDefault();

  //   if (editingRequest) {
  //       // Update an existing swipe record
  //       try {
  //           const response = await fetch(`https://hrmspayroll.prepstripe.com/api/shift-changes/${editingRequest.id}`, {
  //               method: "PUT",
  //               headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
  //               body: JSON.stringify(formData),
  //           });

  //           if (response.ok) {
  //               setRequests(requests.map(req => req.id === editingRequest.id ? { ...req, ...formData } : req));
  //               setNotification("Swipe request updated successfully");
  //               setEditingRequest(null);
  //               resetForm();
  //               setShowModal(false);
  //           } else {
  //             const errorData = await response.json();
  //             const errorMsg = errorData?.error || "Failed to update shift change request";
  //             setNotification(errorMsg); // ✅ only a string
  //             setShowModal(true);
  //         }
  //       } catch (error) {
  //         setShowModal(true);
  //         console.error("Error updating request:", error);
  //         const errorMsg =
  //             error?.message ||
  //             error?.error ||
  //             "An unexpected error occurred while updating the shift change request.";
  //         setNotification(errorMsg); // ✅ only a string
  //     }
  //   } else {
  //       // Add a new swipe record
  //       try {
  //           const response = await fetch("https://hrmspayroll.prepstripe.com/api/shift-changes", {
  //               method: "POST",
  //               headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
  //               body: JSON.stringify({ ...formData, status: "Pending" }),
  //           });

  //           if (response.ok) {
  //               const newRecord = await response.json();
  //               // setRequests([...requests, newRecord]);
  //               setRequests([newRecord, ...requests]); // prepend data - new data first
  //               setNotification("Shift change request added successfully");
  //               setShowModal(false);
  //               setEditingRequest(null);
  //               resetForm();
  //           } else {
  //             const errorData = await response.json();
  //             const errorMsg = errorData?.error || "Failed to add shift change request";
  //             setNotification(errorMsg); // ✅ only a string
  //             setShowModal(true);
  //         }
  //       } catch (error) {
  //         setShowModal(true);
  //         console.error("Error adding request:", error);
  //         const errorMsg =
  //             error?.message ||
  //             error?.error ||
  //             "An unexpected error occurred while addding the shift change request.";
  //         setNotification(errorMsg); // ✅ only a string
  //       }
  //   }
  // };

  const handleAddOrEditRequest = async (e) => {
    e.preventDefault();
    setFormErrors({});
    setError(null);
    setIsSubmitting(true);

    if (editingRequest) {
      // Update an existing swipe record
      try {
        await axios.put(
          `https://hrmspayroll.prepstripe.com/api/shift-changes/${editingRequest.id}`,
          formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setCurrentPage(1);
        fetchShiftChange(1);
        setNotification({
          message: "Shift change request updated successfully",
          type: "success",
        });
        setEditingRequest(null);
        resetForm();
        setShowModal(false);
      } catch (err) {
        console.error("Error updating request:", err);
        if (err.response?.status === 422 && err.response?.data?.errors) {
          setFormErrors(err.response.data.errors);
        } else {
          const errorMsg =
            err?.response?.data?.error ||
            err?.response?.data?.message ||
            err?.message ||
            "An unexpected error occurred while updating the shift change request.";
          setError(errorMsg);
        }
      } finally {
        setIsSubmitting(false);
      }
    } else {
      // Add a new swipe record
      try {
        await axios.post(
          "https://hrmspayroll.prepstripe.com/api/shift-changes",
          { ...formData, status: "Pending" },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setCurrentPage(1);
        fetchShiftChange(1);
        setNotification({
          message: "Shift change request added successfully",
          type: "success",
        });
        setShowModal(false);
        setEditingRequest(null);
        resetForm();
      } catch (err) {
        console.error("Error adding request:", err);
        if (err.response?.status === 422 && err.response?.data?.errors) {
          setFormErrors(err.response.data.errors);
        } else {
          const errorMsg =
            err?.response?.data?.error ||
            err?.response?.data?.message ||
            err?.message ||
            "An unexpected error occurred while adding the shift change request.";
          setError(errorMsg);
        }
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleEdit = (req) => {
    setEditingRequest(req);
    setFormData(req);
    setShowModal(true);
  };

  const handleAdd = () => {
    resetForm();
    setEditingRequest(null);
    setShowModal(true);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      setCurrentPage(newPage);
      fetchShiftChange(newPage);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(
        `https://hrmspayroll.prepstripe.com/api/shift-changes/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.ok) {
        setRequests(requests.filter((req) => req.id !== id));
        // setNotification("Shift Change request deleted successfully");
        setNotification({
          message: "Shift Change request deleted successfully",
          type: "success",
        });
      } else {
        // setNotification("Failed to delete shift change request");
        setNotification({
          message: "Failed to delete shift change request",
          type: "error",
        });
      }
    } catch (error) {
      console.error("Error deleting request:", error);
    }
  };

  const resetForm = () => {
    setFormData({
      shift_date: "",
      current_shift: "GS",
      requested_shift: "",
      reason: "",
    });
    setFormErrors({});
  };

  const getRoleBasedRouteLocal = (route) => getRoleBasedRoute(route, roles);

  return (
    <div className="px-4 py-2 bg-white dark:bg-gray-900 rounded-lg">
      {/* notification compo */}
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}

      {/* Breadcrumb */}
      <nav className="flex flex-wrap mb-4 font-poppins" aria-label="Breadcrumb">
        <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
          <li>
            <div className="flex items-center">
              <Link
                to={getRoleBasedRouteLocal("/admin/attendance_management")}
                className="text-sm sm:text-md font-medium text-black hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-500"
              >
                Attendance Management
              </Link>
            </div>
          </li>
          <li aria-current="page">
            <div class="flex items-center">
              <svg
                class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span class="ms-1 text-sm sm:text-md font-medium text-gray-500 md:ms-2 dark:text-gray-400">
                Shift Change Request
              </span>
            </div>
          </li>
        </ol>
      </nav>

      <h2 className="text-lg sm:text-xl dark:text-white font-poppins font-semibold mb-4">
        Shift Change Requests
      </h2>

      {/* Buttons */}
      <div className="flex flex-col sm:flex-row gap-2 justify-between items-center mb-4">
        {/* search field */}
        <div className="relative w-full sm:w-96">
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full dark:bg-black dark:text-white dark:border-gray-700 placeholder:text-xs md:placeholder:text-sm p-2 pr-8 border border-gray-300 rounded-md"
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery("")}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
              title="Clear search"
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
        {/* Add button at right end */}
        <HasPermission permission="shift_change_requests_create">
          <button
            onClick={() => {
              const hasManager =
                user?.manager || user?.reporting_to || user?.manager_id;
              const canSkipManager = roles?.some((r) =>
                ["Admin", "HR"].includes(r),
              );

              if (!hasManager && !canSkipManager) {
                setNotification({
                  message: "Manager is not allocated.",
                  type: "error",
                });
                return;
              }
              handleAdd(true);
            }}
            className="flex items-center justify-center gap-2 bg-blue-600 font-medium hover:bg-blue-700 text-white px-4 py-2 rounded-md whitespace-nowrap"
          >
            <FaPlus /> Apply Shift Change Request
          </button>
        </HasPermission>
      </div>

      {/* Table */}
      <div className="overflow-x-auto bg-white dark:bg-gray-900 shadow-md font-poppins rounded-lg">
        <table className="min-w-full table-auto md:table-fixed text-sm">
          <thead className="bg-gray-100 dark:bg-gray-800 dark:text-white">
            <tr>
              <th className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">
                Sr No.
              </th>
              <th className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">
                Date
              </th>
              <th className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">
                Requested Shift
              </th>
              <th className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">
                Reason
              </th>
              <th className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">
                Status
              </th>
              <th className="py-2 px-4 dark:text-white text-center font-semibold text-xs md:text-sm text-black whitespace-nowrap">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr className="border-b hover:bg-gray-100 dark:hover:bg-gray-800">
                <td
                  colSpan="7"
                  className="py-2 px-4 text-xs md:text-sm whitespace-nowrap"
                >
                  <div className="animate-spin h-6 w-6 border-2 border-blue-500 border-t-transparent rounded-full mx-auto mb-2 mt-2"></div>
                </td>
              </tr>
            ) : filteredData.length > 0 ? (
              filteredData?.map((req, index) => (
                <tr
                  key={req.id}
                  className="dark:border-gray-700 dark:hover:bg-gray-950 dark:hover:text-white dark:text-white"
                >
                  <td className="py-2 px-4 dark:text-white text-xs md:text-sm whitespace-nowrap font-medium">
                    {index + 1}
                  </td>
                  <td className="py-2 px-4 dark:text-white text-xs md:text-sm whitespace-nowrap">
                    {req.shift_date}
                  </td>
                  <td className="py-2 px-4 dark:text-white text-xs md:text-sm whitespace-nowrap">
                    {req.requested_shift}
                  </td>
                  <td
                    title={req.reason}
                    className="py-2 px-4 dark:text-white text-xs md:text-sm whitespace-nowrap"
                  >
                    {req.reason}
                  </td>
                  <td className="py-2 px-4 dark:text-white text-xs md:text-sm whitespace-nowrap">
                    <StatusBadge status={req?.request?.status} />
                  </td>

                  <td className="p-2 text-center whitespace-nowrap">
                    <div className="relative inline-block">
                      <button
                        ref={openMenu === req.id ? buttonRef : null}
                        className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors focus:outline-none"
                        onClick={() =>
                          setOpenMenu(openMenu === req.id ? null : req.id)
                        }
                      >
                        <MoreVertical className="w-4 h-4 text-gray-600 dark:text-gray-400" />
                      </button>

                      {openMenu === req.id && (
                        <DropdownMenu
                          buttonRef={buttonRef}
                          onClose={() => setOpenMenu(null)}
                          align="right"
                        >
                          <button
                            className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                            onClick={() => {
                              setSelectedRequest(req);
                              setDrawerOpen(true);
                              setOpenMenu(null);
                            }}
                          >
                            View
                          </button>
                          {req.request.status === "pending" && (
                            <HasPermission permission="shift_change_requests_update">
                              <button
                                className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                                onClick={() => {
                                  handleEdit(req);
                                  setOpenMenu(null);
                                }}
                              >
                                Edit
                              </button>
                            </HasPermission>
                          )}
                          <HasPermission permission="shift_change_requests_delete">
                            <DeleteButton
                              className={
                                "block w-full text-left px-4 py-2 text-sm text-red-500 hover:bg-gray-100 dark:hover:bg-gray-700"
                              }
                              onDelete={() => {
                                handleDelete(req.id);
                                setOpenMenu(null);
                              }}
                            />
                          </HasPermission>
                        </DropdownMenu>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="py-4 px-4 text-center text-gray-500">
                  No record found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* pagination */}
      {!isFiltering && filteredData?.length > 0 && (
        <ReactPaginate
          breakLabel="..."
          nextLabel="Next >"
          onPageChange={(event) => handlePageChange(event.selected + 1)}
          forcePage={currentPage - 1}
          pageRangeDisplayed={5}
          disabledClassName="opacity-50 cursor-not-allowed"
          disabledLinkClassName="pointer-events-none"
          pageCount={pagination.totalPages}
          previousLabel="< Prev"
          previousClassName="dark:text-white border border-gray-300 rounded-md dark:border-gray-600"
          previousLinkClassName="block w-full h-full px-3 py-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800"
          nextClassName="dark:text-white border border-gray-300 rounded-md dark:border-gray-600"
          nextLinkClassName="block w-full h-full px-3 py-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800"
          renderOnZeroPageCount={null}
          containerClassName="flex items-center justify-center mt-4 font-poppins"
          pageClassName="mx-1 border rounded dark:text-white font-poppins"
          pageLinkClassName="block w-full h-full px-3 py-1 cursor-pointer"
          activeClassName="bg-blue-500 text-white dark:bg-black dark:text-white dark:border-gray-700 font-poppins"
          activeLinkClassName="bg-blue-500 text-white dark:bg-black dark:text-white hover:bg-blue-600 dark:hover:bg-gray-900"
        />
      )}

      {/* Shift change Form (Modal) */}
      {showModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end md:items-center z-[1001] backdrop-blur-sm"
          onClick={() => {
            setShowModal(false);
            setFormErrors({});
          }}
        >
          <div
            className="bg-white dark:bg-gray-900 font-poppins rounded-md shadow-xl w-full max-w-md mx-auto relative transition-transform duration-300 transform md:animate-none animate-slideUp"
            onClick={(e) => e.stopPropagation()}
          >
            <form
              onSubmit={handleAddOrEditRequest}
              class="bg-white dark:bg-gray-900 sm:rounded-lg rounded-t-2xl"
            >
              {/* modal title */}
              <div className="relative">
                <div className="absolute inset-0 dark:from-gray-800 dark:to-gray-850"></div>
                <div className="relative flex items-center justify-between p-4 ">
                  <div className="flex items-center space-x-3">
                    {/* <div className="w-1 h-6 bg-gradient-to-b from-blue-500 to-purple-600 rounded-full"></div> */}
                    <h2 className="text-xl font-semibold text-gray-900 dark:text-white tracking-tight">
                      {editingRequest ? "Edit" : "Shift Change"}
                    </h2>
                  </div>

                  {/* Enhanced close button */}
                  <button
                    type="button"
                    onClick={() => {
                      setShowModal(false);
                      setFormErrors({});
                    }}
                    className="group relative p-2 rounded-xl transition-all duration-200 hover:scale-105 active:scale-95"
                    aria-label="Close modal"
                  >
                    <X
                      size={20}
                      className="text-gray-600 transition-colors duration-200"
                    />
                    <div className="absolute inset-0 rounded-xl transition-all duration-200"></div>
                  </button>
                </div>
              </div>

              {/* modal body */}
              <div class="max-h-[80vh] dark:bg-gray-900 overflow-y-auto flex flex-col gap-y-2 rounded-lg bg-white p-4">
                {error && (
                  <div className="bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 text-red-600 dark:text-red-400 px-4 py-3 rounded-md mb-4 flex items-start gap-2">
                    <AlertTriangle className="w-5 h-5 flex-shrink-0 mt-0.5" />
                    <span className="text-sm font-medium">{error}</span>
                  </div>
                )}
                {/* effective date field */}
                <label className="block md:text-md text-sm dark:text-white">
                  Effective Date: <span className="text-red-500 ml-1">*</span>
                  <input
                    type="date"
                    name="shift_date"
                    value={formData.shift_date}
                    onChange={(e) => {
                      setFormData({ ...formData, shift_date: e.target.value });
                      if (formErrors.shift_date)
                        setFormErrors({ ...formErrors, shift_date: "" });
                    }}
                    min={new Date().toISOString().split("T")[0]}
                    className={`w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border p-2 rounded-md mt-1 ${
                      formErrors.shift_date
                        ? "border-red-500 focus:border-red-500"
                        : ""
                    }`}
                    required
                  />
                  {formErrors.shift_date && (
                    <p className="text-xs text-red-500 mt-1 flex items-center gap-1 font-poppins">
                      <AlertTriangle className="w-3.5 h-3.5" />
                      {formErrors.shift_date}
                    </p>
                  )}
                </label>

                {/* current shift field */}
                <div className="grid grid-cols-2 gap-4 md:text-md text-sm">
                  <div>
                    <label className="block dark:text-white">
                      Current Shift:{" "}
                      <span className="text-red-500 ml-1">*</span>
                      <select
                        disabled
                        className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border p-2 rounded-md mt-1 bg-gray-100"
                      >
                        <option>GS</option>
                      </select>
                    </label>

                    <p className="md:text-sm text-xs text-gray-600">
                      In: 10:00AM | Out: 7:00PM
                    </p>
                  </div>

                  <label className="block dark:text-white font-medium">
                    New Shift <span className="text-red-500 ml-1">*</span>
                    <select
                      name="requested_shift"
                      value={formData.requested_shift} //|| (shifts.length > 0 ? shifts[0].name : "")}
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          requested_shift: e.target.value,
                        }));
                        if (formErrors.requested_shift)
                          setFormErrors({ ...formErrors, requested_shift: "" });
                      }}
                      className={`w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 p-2 border rounded mt-1 ${
                        formErrors.requested_shift
                          ? "border-red-500 focus:border-red-500"
                          : ""
                      }`}
                      required
                    >
                      <option value="" disabled>
                        -- Select shift --
                      </option>
                      {shifts.map((leave) => (
                        <option key={leave.id} value={leave.name}>
                          {leave.name} ({leave.start_time} - {leave.end_time})
                        </option>
                      ))}
                    </select>
                    {formErrors.requested_shift && (
                      <p className="text-xs text-red-500 mt-1 flex items-center gap-1 font-poppins">
                        <AlertTriangle className="w-3.5 h-3.5" />
                        {formErrors.requested_shift}
                      </p>
                    )}
                  </label>
                </div>

                {/* reason field */}
                <label className="block dark:text-white md:text-md text-sm">
                  Reason: <span className="text-red-500 ml-1">*</span>
                  <textarea
                    name="reason"
                    value={formData.reason}
                    onChange={(e) => {
                      let input = e.target.value;
                      input = input.replace(/[^a-zA-Z\s.,!?']/g, ""); // Allow letters, space, punctuation
                      input = input.replace(/^\s+/, ""); // Remove leading spaces
                      setFormData({ ...formData, reason: input });
                      if (formErrors.reason)
                        setFormErrors({ ...formErrors, reason: "" });
                    }}
                    maxLength={80}
                    className={`w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border p-2 rounded-md mt-1 ${
                      formErrors.reason
                        ? "border-red-500 focus:border-red-500"
                        : ""
                    }`}
                    required
                  ></textarea>
                  {formErrors.reason && (
                    <p className="text-xs text-red-500 mt-1 flex items-center gap-1 font-poppins">
                      <AlertTriangle className="w-3.5 h-3.5" />
                      {formErrors.reason}
                    </p>
                  )}
                  <p className="text-sm text-gray-500 mt-1">
                    {formData.reason.length}/80 characters
                  </p>
                </label>
              </div>

              {/* modal footer */}
              <div class="px-4 py-5 flex justify-end gap-2 items-center">
                <button
                  type="button"
                  onClick={() => {
                    setShowModal(false);
                    setFormErrors({});
                    setError(null);
                  }}
                  className="px-7 py-2 text-black hover:bg-gray-200 font-medium dark:bg-black dark:text-white dark:hover:bg-gray-900 dark:focus:outline-none border border-gray-300 rounded-md"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-blue-600 hover:bg-blue-700 font-medium text-white px-10 py-2 rounded-md flex items-center gap-2 justify-center min-w-[120px]"
                >
                  {isSubmitting && (
                    <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
                  )}
                  {isSubmitting
                    ? "Submitting..."
                    : editingRequest
                      ? "Update"
                      : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal to view details */}
      {drawerOpen && selectedRequest && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[1001] backdrop-blur-sm p-4 font-poppins"
          onClick={() => setDrawerOpen(false)}
        >
          <div
            className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header with Gradient */}
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-5">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="p-2.5 bg-white/20 rounded-xl backdrop-blur-sm">
                    <svg
                      className="w-6 h-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-white uppercase tracking-tight">
                    Shift Change Details
                  </h3>
                </div>
                <button
                  onClick={() => setDrawerOpen(false)}
                  className="p-2 hover:bg-white/20 rounded-lg transition-colors"
                >
                  <X className="w-6 h-6 text-white" />
                </button>
              </div>
            </div>

            {/* Content */}
            <div className="p-6 overflow-y-auto max-h-[calc(90vh-200px)] bg-white dark:bg-gray-900">
              {/* Status Badge - Centered */}
              <div className="mb-6 flex justify-center">
                <StatusBadge
                  status={selectedRequest.request?.status || "pending"}
                />
              </div>

              {/* Information Cards Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                {/* Effective Date */}
                <div className="bg-gray-50 dark:bg-gray-800/50 rounded-xl p-4 border border-gray-200 dark:border-gray-700">
                  <div className="flex items-start gap-3">
                    <div className="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
                      <svg
                        className="w-5 h-5 text-blue-600 dark:text-blue-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1">
                        Effective Date
                      </p>
                      <p className="text-base font-semibold text-gray-900 dark:text-white">
                        {selectedRequest.shift_date}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Current Shift */}
                <div className="bg-gray-50 dark:bg-gray-800/50 rounded-xl p-4 border border-gray-200 dark:border-gray-700">
                  <div className="flex items-start gap-3">
                    <div className="p-2 bg-green-100 dark:bg-green-900/30 rounded-lg">
                      <svg
                        className="w-5 h-5 text-green-600 dark:text-green-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1">
                        Current Shift
                      </p>
                      <p className="text-base font-semibold text-gray-900 dark:text-white">
                        {selectedRequest.current_shift}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Requested Shift */}
                <div className="bg-gray-50 dark:bg-gray-800/50 rounded-xl p-4 border border-gray-200 dark:border-gray-700">
                  <div className="flex items-start gap-3">
                    <div className="p-2 bg-orange-100 dark:bg-orange-900/30 rounded-lg">
                      <svg
                        className="w-5 h-5 text-orange-600 dark:text-orange-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                        />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1">
                        Requested Shift
                      </p>
                      <p className="text-base font-semibold text-gray-900 dark:text-white">
                        {selectedRequest.requested_shift}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Reason Section */}
              <div className="bg-gray-50 dark:bg-gray-800/50 rounded-xl p-5 border border-gray-200 dark:border-gray-700">
                <h4 className="font-bold text-gray-800 dark:text-white mb-3 tracking-wide uppercase text-xs">
                  Reason
                </h4>
                <p className="text-sm text-gray-700 dark:text-gray-300 leading-relaxed font-medium">
                  {selectedRequest.reason || "No reason provided"}
                </p>
              </div>

              {/* Approver Comments Section */}
              {selectedRequest.request?.approver_comments &&
                selectedRequest.request?.action_date && (
                  <div className="mt-4 bg-blue-50 dark:bg-blue-900/20 rounded-xl p-5 border border-blue-200 dark:border-blue-800 shadow-sm">
                    <h4 className="text-sm font-bold text-blue-600 dark:text-blue-400 mb-3 uppercase tracking-wider">
                      Approver's Comment
                    </h4>
                    <p className="text-base text-gray-800 dark:text-gray-200 mb-3 font-semibold">
                      {selectedRequest.request.approver_comments}
                    </p>
                    <div className="flex items-center gap-2 text-xs text-gray-600 dark:text-gray-400">
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                      <span>
                        Request {selectedRequest.request.status} on:{" "}
                        {selectedRequest.request.action_date}
                      </span>
                    </div>
                  </div>
                )}
            </div>

            {/* Footer */}
            <div className="px-6 py-4 bg-gray-50 dark:bg-gray-800/50 border-t dark:border-gray-800 flex justify-end">
              <button
                onClick={() => setDrawerOpen(false)}
                className="px-8 py-2.5 rounded-xl border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 font-bold hover:bg-gray-100 dark:hover:bg-gray-800 transition-all active:scale-95"
              >
                CLOSE
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShiftChange;
